module.exports = __webpack_public_path__ + "static/media/amanat_nagari_logo.8a2da9eb.png";